import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';

import AppErrorBoundary from './components/common/AppErrorBoundary';
import ToastContainer from './components/common/ToastContainer';
import AppRoutes from './routes/AppRoutes';
import { ThemeProvider } from './providers/ThemeProvider';
import { TooltipProvider } from './providers/TooltipProvider';
import { ToasterProvider } from './providers/ToasterProvider';
import { initializeSecurity } from './utils/security';
import './App.css';

// Criar instância do QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos
      retry: 1,
    },
  },
});

function App() {
  useEffect(() => {
    // Inicializar configurações de segurança
    initializeSecurity();
  }, []);

  return (
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TooltipProvider>
            <ToasterProvider>
              <div className="App">
                <AppRoutes />
                <Toaster
                  position="top-right"
                  expand={true}
                  richColors={true}
                  closeButton={true}
                />
                <ToastContainer />
              </div>
            </ToasterProvider>
          </TooltipProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </AppErrorBoundary>
  );
}

export default App;
